import { PAS_BASE_PATH } from '../../../core/constants/pasRoutes';

// The contract's planCode: unpadded decimal digits (D85), so it is always exactly one path segment.
const PLAN_CODE = /^[0-9]+$/;

/**
 * Turns the `pasnavigate` detail raised by `b2o-pas-widget` into a host route. The detail carries
 * an intent, never a URL, so anything unrecognised is dropped rather than followed.
 */
export const resolvePasNavigation = (detail: unknown): string | null => {
  if (typeof detail !== 'object' || detail === null) return null;
  const { to, planCode } = detail as { to?: unknown; planCode?: unknown };

  if (to === 'create') return `${PAS_BASE_PATH}/new`;
  if (to === 'list') return PAS_BASE_PATH;
  if (to === 'detail' && typeof planCode === 'string' && PLAN_CODE.test(planCode)) {
    return `${PAS_BASE_PATH}/${planCode}`;
  }
  return null;
};
